import React from 'react'
import { ValFormReg } from '../../../Validators/ValForms';
import { RegularExpressions } from '../../../Helpers/RegularExpression';


export const ValTasaInteresValores = (state) => {
    // const nuevousado = ValForm("Nuevo o Usado", state.nuevousado);
    const plazo = ValFormReg(
        "PLAZO",
        state.plazo,
        RegularExpressions.TextOnlyNumber
    );
    const porcentaje = ValFormReg(
        "PORCENTAJE",
        state.porcentaje,
        RegularExpressions.TextOnlyNumber
    );
    
    var isValid = true;
    var mensaje = "";
    if (plazo.isValid === false) {
        state.bplazo = true;
        isValid = false;
        mensaje += plazo.mensaje;
    }
    if (porcentaje.isValid === false) {
        state.bporcentaje = true;
        isValid = false;
        mensaje += porcentaje.mensaje;
    }
    if (isValid === false) {
        return { isValid, state, mensaje };
    } else {
        return {
            isValid,
            post: {
                idtipo_tasa_valor: 0,
                idtipo_tasa:0,
                plazo: state.plazo,
                porcentaje: state.porcentaje,
            },
        };
    }
};


